<template>
  <div class="container">
    <div class="layout">
      <div class="info" v-for="(it, index) in list" :key="it.articleTypeId">
        <div class="ewp_news_w1">
          <!-- <div class="title clearfix">
            <p frag="标题">{{ it.title }}</p>
            <span frag="按钮" type="更多" @click="tomore(it)">
              <a class="w3_more"><span frag="按钮内容">更多</span></a>
            </span>
          </div> -->
          <ul>
            <li v-for="article in it.artcleList" :key="article.id">
              <a
                target="_blank"
                :title="article.articleTitle"
                @click="toDeatil(article)"
                >{{ article.articleTitle }}</a
              >
              <span>{{ article.createTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// window.addEventListener('message', handleMessage,false)
// function handleMessage(e) {
//   if (e.data.status === "articleMsg-ok") {
//     console.log(e.data.params.articleTypeId); //文章类型id
//     console.log(e.data.params.articleTypeTitle); // 文章类型名称
//     console.log(e.data.params.artilceId); // 文章id
//   }
// }
import { getList, articleDetail } from "@/api/article";
export default {
  name: "index",
  components: {},
  data() {
    return {
      list: [
        {
          title: "通知公告",
          articleTypeId: 107,
          artcleList: [],
        },
      ],
    };
  },
  computed: {},
  created() {
    this.getArticleList();
  },
  methods: {
    getArticleList() {
      this.list.forEach(async (item, index) => {
        const { code, data } = await getList({
          articleTypeId: item.articleTypeId,
          pageNum: 1, //页码 默认为1
          pageSize: 6, //每页记录数 默认为10
        });
        if (code == 200) {
          this.list[index].artcleList = data;
        }
      });
    },
    tomore(data) {
      window.parent.postMessage(
        {
          status: "articleMsg-ok",
          params: {
            articleTypeId: data.articleTypeId,
            articleTypeTitle: data.title,
          },
        },
        "*"
      );
      // this.$router.push({
      //   path: "/listPage",
      //   query: {
      //     articleTypeId: data.articleTypeId,
      //     articleTypeTitle: data.title,
      //   },
      // });
    },
    async toDeatil(article) {
      if (article.isOuterChain == 0) {
        //外链
        window.open(article.articleContent);
      } else {
      window.parent.postMessage(
        {
          status: "articleMsg-ok",
          params: {
            artilceId: article.id,
          },
        },
        "*"
      );
      let routeUrl = this.$router.resolve({
        path: "/detail",
        query: {
          artilceId: article.id,
        },
      });
      window.open(routeUrl.href, "_blank");
    }
      // this.$router.push({
      //   path: "/detail",
      //   query: {
      //     artilceId: article.id,
      //   },
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
// .layout {
//   display: flex;
//   justify-content: center;
//   flex-wrap: wrap;
// }
.container {
  max-width: 1200px;
  margin: 0 auto;
  .title {
    width: 100%;
    position: relative;
    margin-top: 30px;
    p {
      margin: 0px;
      padding: 0px;
      height: 40px;
      position: relative;
      font: 24px/40px "microsoft yahei";
      color: #333;
      cursor: pointer;
    }
    .w3_more {
      text-decoration: none !important;
      height: 28px;
      display: block;
      padding: 0 15px;
      position: absolute;
      right: 0;
      top: 5px;
      line-height: 28px;
      font-size: 14px;
      border: 1px solid #9a9a9a;
      color: #9a9a9a;
    }
  }
  .info {
    font-size: 16px;
    color: #333;
    margin: 0px;
    padding: 0px;
    float: left;
    width: 590px;
    position: relative;
  }
  .ewp_news_w1 {
    font-family: "microsoft yahei";
    font-size: 16px;
    color: #333;
    margin: 0px;
    padding: 0px;
    ul {
      font-family: "microsoft yahei";
      font-size: 16px;
      color: #333;
      margin: 0px;
      padding: 0px;
      li {
        font-size: 16px;
        color: #333;
        margin: 0px;
        padding: 0px;
        list-style: none;
        line-height: 50px;
        padding-left: 2px;
        position: relative;
        overflow: hidden;
        border-bottom: 1px dashed #ececec;
        a {
          line-height: 50px;
          color: #333;
          text-decoration: none !important;
          display: block;
          width: 100%;
          box-sizing: border-box;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 20px 0 110px;
        }
        span {
          list-style: none;
          position: absolute;
          right: 8px;
          font-size: 14px;
          width: 100px;
          height: 30px;
          left: 0;
          top: 10px;
          line-height: 30px;
          background-color: #003f88;
          color: #fff;
          text-align: center;
        }
      }
    }
  }
  .wp_news_w2 {
    ul {
      li {
        position: relative;
        --antd-wave-shadow-color: #1890ff;
        -webkit-text-size-adjust: 100%;
        font-variant: tabular-nums;
        line-height: 1.5;
        font-feature-settings: "tnum";
        font-family: "Microsoft Yahei", "微软雅黑", "宋体", arial,
          "Hiragino Sans GB", Tahoma, Arial, Helvetica;
        color: #333;
        margin: 0;
        padding: 0;
        font-size: 12px;
        box-sizing: border-box;
        border: none;
        -webkit-tap-highlight-color: transparent;
        list-style: none;
        img {
          font-size: 16px;
          color: #333;
          list-style: none;
          line-height: 50px;
          vertical-align: middle;
          outline: none;
          border: 0;
          position: absolute;
          left: 8px;
          top: 18px;
          margin-right: 10px;
        }
        a {
          font-family: "microsoft yahei";
          list-style: none;
          line-height: 50px;
          color: #333;
          text-decoration: none !important;
          display: block;
          width: 100%;
          box-sizing: border-box;
          padding: 0 90px 0 20px;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span {
          list-style: none;
          line-height: 50px;
          position: absolute;
          right: 8px !important;
          top: 0 !important;
          color: #999;
          font-size: 14px;
          background-color: transparent !important;
        }
      }
    }
  }
}
</style>
